import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27d6dba0")

_pushScopeId("data-v-27d6dba0")
const _hoisted_1 = { class: "video-section" }
const _hoisted_2 = { class: "panel-holder" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VideoPanel = _resolveComponent("VideoPanel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webinars, (w, i) => {
        return (_openBlock(), _createBlock(_component_VideoPanel, {
          webinar: w,
          shouldLoad: i < _ctx.NO_OF_PRELOADS,
          key: i
        }, null, 8, ["webinar", "shouldLoad"]))
      }), 128)),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(10)
          .fill(1)
          .map((e, i) => e + i * 1), (i) => {
        return (_openBlock(), _createBlock("div", {
          class: "panel",
          key: i
        }))
      }), 128))
    ])
  ]))
})